var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
import orderNewCardSuccess from "././assets/order-new-card-success.svg";
import orderNewCardError from "././assets/order-new-card-error.svg";
import leaveOrExitWarning from "././assets/leaveOrExitWarning.svg";
var LEGACY_ORDER_NEW_CARD_MODULE_ASSETS_MAP = {
  ORDER_NEW_CARD_SUCCESS: orderNewCardSuccess,
  ORDER_NEW_CARD_ERROR: orderNewCardError,
  LEAVE_OR_EXIT_WARNING: leaveOrExitWarning
};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(LEGACY_ORDER_NEW_CARD_MODULE_ASSETS_MAP);
};

// src/components/order-new-card.component.tsx
import { useIntl as useIntl12 } from "@leagueplatform/locales";
import * as React19 from "react";
import {
  Button as Button4,
  HeadingBar,
  Modal,
  VisuallyHidden as VisuallyHidden2
} from "@leagueplatform/genesis-core";

// src/components/order-new-card-form.component.tsx
import * as React18 from "react";
import {
  Box as Box10,
  HeadingText as HeadingText8,
  StackLayout as StackLayout8,
  styled as styled3
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl11 } from "@leagueplatform/locales";
import {
  useForm,
  ReactHookFormProvider as FormProvider
} from "@leagueplatform/web-common";
import { EVENT_NAME as EVENT_NAME3, PRODUCT_AREA as PRODUCT_AREA2 } from "@leagueplatform/analytics";

// src/hooks/use-wallet-detail-analytics.hook.ts
import {
  trackAnalyticsEvent,
  SCREEN_NAMES,
  PRODUCT_AREA,
  usePageViewAnalytics
} from "@leagueplatform/analytics";
import * as React from "react";
var useWalletDetailAnalytics = (partialParams, analyticsData = {
  benefitId: "",
  vendorId: "",
  benefitName: "",
  benefitSource: "",
  productType: ""
}) => {
  const benefitData = React.useMemo(
    () => ({
      product_area: PRODUCT_AREA.WALLET,
      screen_name: SCREEN_NAMES.BENEFIT_PAGE,
      benefit_id: analyticsData.benefitId,
      benefit_name: analyticsData.benefitName,
      benefit_product_type: analyticsData.productType,
      benefit_source: analyticsData.benefitSource,
      vendor_id: analyticsData.vendorId
    }),
    [analyticsData]
  );
  return (eventName, props) => {
    trackAnalyticsEvent(eventName, __spreadValues(__spreadValues(__spreadValues({}, benefitData), partialParams), props));
  };
};
var useWalletDetailScreenLoaded = (screenName, analyticsData = {
  benefitId: "",
  vendorId: "",
  benefitName: "",
  benefitSource: "",
  productType: ""
}) => {
  const benefitData = React.useMemo(
    () => ({
      benefit_id: analyticsData.benefitId,
      benefit_name: analyticsData.benefitName,
      benefit_product_type: analyticsData.productType,
      benefit_source: analyticsData.benefitSource,
      product_area: PRODUCT_AREA.WALLET,
      screen_name: SCREEN_NAMES.BENEFIT_PAGE,
      vendor_id: analyticsData.vendorId
    }),
    [analyticsData]
  );
  usePageViewAnalytics(__spreadProps(__spreadValues({}, benefitData), { screen_name: screenName }));
};

// src/hooks/use-submit-order-new-card-mutation.hook.ts
import * as React3 from "react";
import { useMutation } from "@tanstack/react-query";
import {
  postIdCards
} from "@leagueplatform/wallet-api";

// src/hooks/use-get-user-default-address.hook.ts
import * as React2 from "react";
import { useGetUserProfile } from "@leagueplatform/web-common";
var useGetUserDefaultAddress = () => {
  var _a;
  const { data: user } = useGetUserProfile();
  const { address1, address2, city: city2, postal: postal2, state: state2 } = React2.useMemo(
    () => {
      var _a2, _b;
      return (_b = (_a2 = user == null ? void 0 : user.userProfile) == null ? void 0 : _a2.locations) == null ? void 0 : _b.find((location) => location.isDefault);
    },
    [(_a = user == null ? void 0 : user.userProfile) == null ? void 0 : _a.locations]
  ) || {};
  return { address1, address2, city: city2, postal: postal2, state: state2 };
};

// src/hooks/use-submit-order-new-card-mutation.hook.ts
var useSubmitOrderNewCardMutation = (benefitId) => {
  const {
    address1 = "",
    address2 = "",
    city: defaultCity = "",
    postal: postalCode = "",
    state: defaultState = ""
  } = useGetUserDefaultAddress();
  const defaultAddress = React3.useMemo(
    () => ({
      streetAddressLine1: address1,
      streetAddressLine2: address2,
      city: defaultCity,
      postalCode,
      province: defaultState
    }),
    [address1, address2, defaultCity, postalCode, defaultState]
  );
  return useMutation((data) => {
    const {
      addressLine1: addressLine13,
      addressLine2: addressLine23,
      postal: postal2,
      state: state2,
      city: city2,
      memberList: memberListData,
      isDefault: isDefault3
    } = data;
    const newAddress = {
      streetAddressLine1: addressLine13,
      streetAddressLine2: addressLine23,
      city: city2,
      postalCode: postal2,
      province: state2
    };
    const isSingleMember = !Array.isArray(memberListData);
    const memberList3 = isSingleMember ? [memberListData] : memberListData;
    const isDefaultAddress2 = isDefault3 === "true";
    const address = isDefaultAddress2 ? defaultAddress : newAddress;
    const submitData = {
      benefitId,
      address,
      memberList: memberList3
    };
    return postIdCards({ data: submitData });
  });
};

// src/constants/form-inputs.constants.ts
var orderNewCardFormInputNames = {
  addressLine1: "addressLine1",
  addressLine2: "addressLine2",
  city: "city",
  state: "state",
  postal: "postal",
  isDefault: "isDefault",
  memberList: "memberList"
};

// src/utils/check-is-default-address.ts
var checkIsDefaultAddress = (isDefaultAddress2) => {
  if (isDefaultAddress2 === "false")
    return false;
  if (isDefaultAddress2 === "true")
    return true;
  return isDefaultAddress2;
};

// src/hooks/use-select-members-step.hook.ts
import { useGetUserProfile as useGetUserProfile2 } from "@leagueplatform/web-common";
var useSelectMembersStep = (dependentArray) => {
  var _a;
  const { data: userProfile, isLoading } = useGetUserProfile2();
  const { firstName, lastName } = (_a = userProfile == null ? void 0 : userProfile.userProfile) != null ? _a : {};
  const userId = userProfile == null ? void 0 : userProfile.userId;
  const memberOptions = [
    {
      label: `${firstName} ${lastName}`,
      value: userId || ""
    },
    ...dependentArray.map(
      ({
        firstName: dependentFirstName,
        lastName: dependentLastName,
        dependentId
      }) => ({
        label: `${dependentFirstName} ${dependentLastName}`,
        value: dependentId
      })
    )
  ];
  return { memberOptions, isLoading };
};

// src/components/multi-step-layout.component.tsx
import React4 from "react";
import { Box, StackLayout, styled } from "@leagueplatform/genesis-core";

// src/constants/multi-step-footer-constants.ts
var ACTIVITY_CONTENT_BASE_WIDTH = 484;
var EASING = Object.freeze({
  IN_OUT_QUAD: `cubic-bezier(0.45, 0, 0.55, 1)`
});
var baseDurationMs = 150;
var TRANSITION_DURATION_MS = Object.freeze({
  SHORT: baseDurationMs,
  MEDIUM: baseDurationMs * 2,
  LONG: baseDurationMs * 3,
  XLONG: baseDurationMs * 4
});
var { MEDIUM, XLONG } = TRANSITION_DURATION_MS;
var { IN_OUT_QUAD } = EASING;
var TRANSITIONS = Object.freeze({
  PAGE: `${XLONG}ms ${IN_OUT_QUAD}`,
  HALF_PAGE: `${MEDIUM}ms ${IN_OUT_QUAD}`
});
var MultiStepFooterAreas = /* @__PURE__ */ ((MultiStepFooterAreas2) => {
  MultiStepFooterAreas2["Top"] = "top";
  MultiStepFooterAreas2["Start"] = "start";
  MultiStepFooterAreas2["Center"] = "center";
  MultiStepFooterAreas2["End"] = "end";
  MultiStepFooterAreas2["Bottom"] = "bottom";
  return MultiStepFooterAreas2;
})(MultiStepFooterAreas || {});

// src/components/multi-step-layout.component.tsx
var FullPageHeight = styled(Box, {
  height: "100%",
  inset: 0,
  position: "absolute",
  backgroundColor: "$surfaceBackgroundTertiary"
});
var ContentPosition = styled(StackLayout, {
  padding: "$oneAndHalf 0",
  paddingTop: "$five",
  transition: `all ${TRANSITIONS.PAGE}`,
  overflow: "hidden"
});
ContentPosition.defaultProps = {
  horizontalAlignment: "center",
  verticalAlignment: "center"
};
var ContentWrapper = styled(StackLayout, {
  position: "relative",
  width: ACTIVITY_CONTENT_BASE_WIDTH,
  maxWidth: "100%"
});
ContentWrapper.defaultProps = {
  orientation: "vertical",
  horizontalAlignment: "center"
};
var MultiStepLayout = ({ children }) => /* @__PURE__ */ React4.createElement(FullPageHeight, { "data-testid": "multi-step-page" }, /* @__PURE__ */ React4.createElement(ContentPosition, { "data-testid": "multi-step-layout" }, /* @__PURE__ */ React4.createElement(ContentWrapper, { "data-testid": "multi-step-content-wrapper" }, children)));

// src/components/multi-step-slider.component.tsx
import * as React5 from "react";
import { Transition } from "react-transition-group";
import { Box as Box2 } from "@leagueplatform/genesis-core";
import { usePrefersReducedMotion } from "@leagueplatform/web-common";
var slideTransition = `transform ${TRANSITIONS.PAGE}, opacity ${TRANSITIONS.PAGE}`;
var reducedMotionSlideTransition = `opacity ${TRANSITIONS.PAGE}`;
var reducedMotionSlideStyles = {
  insetInlineStart: 0,
  transform: "none",
  transition: reducedMotionSlideTransition
};
var useSlideTransitionStyles = ({
  slideIndex,
  gap,
  activeIndex
}) => {
  const prefersReducedMotion = usePrefersReducedMotion();
  const slideStyles = React5.useMemo(
    () => ({
      insetInlineStart: `calc(${slideIndex} * ${gap})`,
      transform: `translateX(calc(-${gap} * ${activeIndex}))`,
      transition: slideTransition
    }),
    [slideIndex, gap, activeIndex]
  );
  return React5.useMemo(
    () => prefersReducedMotion ? reducedMotionSlideStyles : slideStyles,
    [prefersReducedMotion, slideStyles]
  );
};
var MultiStepSlide = ({
  children,
  gap = "100%",
  slideIndex,
  activeIndex
}) => {
  const slideTransitionStyles = useSlideTransitionStyles({
    gap,
    slideIndex,
    activeIndex
  });
  return /* @__PURE__ */ React5.createElement(
    Box2,
    {
      "aria-hidden": activeIndex !== slideIndex,
      css: __spreadValues({
        height: "100%",
        width: "100%",
        position: "absolute",
        top: 0,
        opacity: Number(activeIndex === slideIndex),
        overflowY: "auto"
      }, slideTransitionStyles),
      className: "multi-step-slide"
    },
    /* @__PURE__ */ React5.createElement(
      Transition,
      {
        in: activeIndex === slideIndex,
        timeout: TRANSITION_DURATION_MS.XLONG,
        unmountOnExit: true
      },
      children
    )
  );
};
var MultiStepSlider = ({ children }) => /* @__PURE__ */ React5.createElement(
  Box2,
  {
    css: {
      height: "100%",
      width: "100%",
      position: "relative",
      display: "flex"
    },
    className: "multi-step-slider"
  },
  children
);

// src/components/select-members-step.component.tsx
import * as React6 from "react";
import {
  HeadingText,
  ParagraphText,
  Checkbox,
  Fieldset
} from "@leagueplatform/genesis-core";
import { useIntl } from "@leagueplatform/locales";
import { StackLayout as StackLayout2 } from "@leagueplatform/web-common-components";
import { useFormContext } from "@leagueplatform/web-common";
var MEMBER_HINT_ID = "select-member-hint";
var { memberList } = orderNewCardFormInputNames;
var SelectMembersStep = ({
  members,
  analyticsData
}) => {
  var _a;
  const { register, formState } = useFormContext();
  const { formatMessage } = useIntl();
  useWalletDetailScreenLoaded(
    "order a new card" /* ORDER_NEW_CARD_SELECT_MEMBER_STEP */,
    analyticsData
  );
  const errorMessage = (_a = formState.errors.memberList) == null ? void 0 : _a.message;
  return /* @__PURE__ */ React6.createElement(
    Fieldset,
    {
      hint: /* @__PURE__ */ React6.createElement(ParagraphText, null, formatMessage({ id: "ORDER_NEW_CARD_MEMBER_SELECT_HELP_TEXT" })),
      id: MEMBER_HINT_ID,
      inputStatus: errorMessage ? "error" : void 0,
      legend: /* @__PURE__ */ React6.createElement(HeadingText, { size: "lg", level: "3" }, formatMessage({ id: "ORDER_NEW_CARD_MEMBER_SELECT_HEADING" })),
      required: true,
      statusMessage: errorMessage
    },
    /* @__PURE__ */ React6.createElement(StackLayout2, { space: "$one", css: { marginTop: "$one" } }, members.map((member) => /* @__PURE__ */ React6.createElement(
      Checkbox,
      __spreadValues({
        key: member.value,
        id: member.value,
        label: member.label,
        value: member.value
      }, register(memberList, {
        required: formatMessage({
          id: "WALLET_ORDER_NEW_CARD_SELECT_MEMBER_ERROR"
        })
      }))
    )))
  );
};

// src/components/select-address-step.component.tsx
import { Fieldset as Fieldset2, HeadingText as HeadingText3, Radio } from "@leagueplatform/genesis-core";
import { useIntl as useIntl4 } from "@leagueplatform/locales";
import { StackLayout as StackLayout3 } from "@leagueplatform/web-common-components";
import { useFormContext as useFormContext4 } from "@leagueplatform/web-common";
import * as React9 from "react";

// src/hooks/use-select-address-step.hook.ts
import { useIntl as useIntl2 } from "@leagueplatform/locales";
import * as React7 from "react";
import { useFormContext as useFormContext2 } from "@leagueplatform/web-common";

// src/utils/format-address.util.ts
var formatAddress = (address1, city2, postal2, state2, address2) => `${address1} ${address2 || ""} ${city2}, ${state2} ${postal2}`;

// src/hooks/use-select-address-step.hook.ts
var {
  addressLine1,
  addressLine2,
  city: cityInput,
  state: stateInput,
  postal: postalInput,
  isDefault
} = orderNewCardFormInputNames;
var useSelectAddressStep = () => {
  const { formatMessage } = useIntl2();
  const { getValues, setValue } = useFormContext2();
  const { address1, address2, city: city2, postal: postal2, state: state2 } = useGetUserDefaultAddress();
  const isDefaultAddress2 = checkIsDefaultAddress(getValues(isDefault));
  React7.useEffect(() => {
    if (isDefaultAddress2 === null || void 0)
      return;
    if (isDefaultAddress2) {
      setValue(addressLine1, address1);
      setValue(addressLine2, address2);
      setValue(cityInput, city2);
      setValue(stateInput, state2);
      setValue(postalInput, postal2);
    } else {
      setValue(addressLine1, void 0);
      setValue(addressLine2, void 0);
      setValue(cityInput, void 0);
      setValue(stateInput, void 0);
      setValue(postalInput, void 0);
    }
  }, [address1, address2, city2, isDefaultAddress2, postal2, setValue, state2]);
  const options = React7.useMemo(
    () => [
      {
        label: formatMessage({ id: "DEFAULT_ADDRESS" }),
        hint: formatAddress(address1, city2, postal2, state2, address2),
        isDefault: true
      },
      {
        label: formatMessage({ id: "CHOOSE_NEW_ADDRESS" }),
        hint: formatMessage({ id: "CHOOSE_NEW_ADDRESS_HINT" }),
        isDefault: false
      }
    ],
    [address1, address2, city2, formatMessage, postal2, state2]
  );
  return { options };
};

// src/components/member-selection-card.component.tsx
import {
  Box as Box3,
  Icon,
  ParagraphText as ParagraphText2,
  HeadingText as HeadingText2,
  StackItem
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl3 } from "@leagueplatform/locales";
import * as React8 from "react";
import { useFormContext as useFormContext3 } from "@leagueplatform/web-common";
var { memberList: memberList2 } = orderNewCardFormInputNames;
var MemberCard = ({
  headingLevel,
  members: memberOptions
}) => {
  const { formatMessage } = useIntl3();
  const { getValues } = useFormContext3();
  const selectedMembers = getValues(memberList2);
  const members = memberOptions.filter(
    (member) => selectedMembers.includes(member.value)
  );
  return /* @__PURE__ */ React8.createElement(
    StackItem,
    {
      css: {
        flexDirection: "row",
        margin: "$oneAndHalf 0"
      }
    },
    /* @__PURE__ */ React8.createElement(
      Box3,
      {
        css: {
          backgroundColor: "$surfaceBackgroundSecondary",
          padding: "$threeQuarters",
          borderRadius: "$circle",
          height: "fit-content",
          marginInlineEnd: "$one",
          alignSelf: "center",
          flexGrow: "0"
        }
      },
      /* @__PURE__ */ React8.createElement(Icon, { icon: "descriptivePaymentCard", tint: "$onSurfaceIconPrimary" })
    ),
    /* @__PURE__ */ React8.createElement(Box3, null, /* @__PURE__ */ React8.createElement(HeadingText2, { level: `${headingLevel}`, size: "md" }, formatMessage({ id: "MEDICAL_ID_CARD" })), /* @__PURE__ */ React8.createElement("ul", null, members.map(({ label }, i) => /* @__PURE__ */ React8.createElement("li", { key: `member-${label.replace(" ", "-")}` }, /* @__PURE__ */ React8.createElement(ParagraphText2, null, i === members.length - 1 ? `${label}` : `${label},`)))))
  );
};

// src/components/select-address-step.component.tsx
var ADDRESS_HINT_ID = "select-address-hint";
var { isDefault: isDefault2 } = orderNewCardFormInputNames;
var SelectAddressStep = ({
  analyticsData,
  members
}) => {
  var _a;
  const { formatMessage } = useIntl4();
  const { options } = useSelectAddressStep();
  const { register, formState } = useFormContext4();
  useWalletDetailScreenLoaded(
    "order a new card enter delivery address" /* ORDER_NEW_CARD_SELECT_ADDRESS_STEP */,
    analyticsData
  );
  const errorMessage = (_a = formState.errors[isDefault2]) == null ? void 0 : _a.message;
  return /* @__PURE__ */ React9.createElement(React9.Fragment, null, /* @__PURE__ */ React9.createElement(MemberCard, { headingLevel: 4, members }), /* @__PURE__ */ React9.createElement(
    Fieldset2,
    {
      inputStatus: errorMessage ? "error" : void 0,
      id: ADDRESS_HINT_ID,
      legend: /* @__PURE__ */ React9.createElement(HeadingText3, { size: "lg", level: "3" }, formatMessage({ id: "ORDER_NEW_CARD_ADDRESS_SELECT_HEADING" })),
      required: true,
      statusMessage: errorMessage
    },
    /* @__PURE__ */ React9.createElement(StackLayout3, { space: "$one", css: { marginTop: "$one" } }, options.map((option, i) => /* @__PURE__ */ React9.createElement(
      Radio,
      __spreadValues({
        css: {
          borderRadius: "$medium",
          border: "$onSurfaceBorderDefault thin solid"
        },
        hint: option.hint,
        id: `address-option-${i}`,
        key: `address-is-default-${option.isDefault}`,
        label: option.label,
        layout: "row",
        value: `${option.isDefault}`
      }, register(isDefault2, {
        required: formatMessage({
          id: "WALLET_ORDER_NEW_CARD_SELECT_ADDRESS_OPTION_ERROR"
        })
      }))
    )))
  ));
};

// src/components/new-address-step.component.tsx
import * as React10 from "react";
import {
  Fieldset as Fieldset3,
  HeadingText as HeadingText4,
  InputLabel,
  ParagraphText as ParagraphText3,
  TextInput,
  Select,
  InputStatusMessage,
  styled as styled2,
  StackLayout as StackLayout4,
  Box as Box4
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl5 } from "@leagueplatform/locales";
import {
  PROVINCE_STATE_OPTIONS,
  useFormContext as useFormContext5
} from "@leagueplatform/web-common";

// src/utils/validate-valid-characters.util.ts
var VALID_CHARACTERS_REGEX = /^(\w|\s|-)*$/i;
var validateIsValidCharacters = (value) => VALID_CHARACTERS_REGEX.test(value) === true;

// src/components/new-address-step.component.tsx
var NEW_ADDRESS_HINT_ID = "new-address-hint";
var CITY_VALIDATION_REGEX = /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/;
var ZIP_CODE_VALIDATION_REGEX = /^[0-9]{5}$/;
var transformedStateOptions = PROVINCE_STATE_OPTIONS.US.map(
  ({ value, text }) => ({
    label: text,
    value
  })
);
var StyledInputLabel = styled2(InputLabel, {
  marginBottom: "$half"
});
var { addressLine1: addressLine12, addressLine2: addressLine22, city, postal, state } = orderNewCardFormInputNames;
var NewAddressStep = ({
  analyticsData
}) => {
  var _a, _b, _c, _d, _e;
  const { formatMessage, $tmap } = useIntl5();
  const { register, formState } = useFormContext5();
  useWalletDetailScreenLoaded(
    "order a new card enter new address" /* ORDER_NEW_CARD_NEW_ADDRESS_STEP */,
    analyticsData
  );
  const requiredFieldError = (id) => formatMessage(
    { id: "REQUIRED_FIELD" },
    {
      field: $tmap({
        ["addressLine1" /* ADDRESS_LINE_1 */]: "ADDRESS_LINE_1",
        ["addressLine2" /* ADDRESS_LINE_2 */]: "ADDRESS_LINE_2",
        ["city" /* CITY */]: "CITY",
        ["state" /* STATE */]: "STATE",
        ["postal" /* POSTAL */]: "ZIP_CODE"
      })(id)
    }
  );
  const addressLine1Error = (_a = formState.errors[addressLine12]) == null ? void 0 : _a.message;
  const addressLine1ErrorId = `${"addressLine1" /* ADDRESS_LINE_1 */}-errorMessage`;
  const addressLine2Error = (_b = formState.errors[addressLine22]) == null ? void 0 : _b.message;
  const addressLine2ErrorId = `${"addressLine2" /* ADDRESS_LINE_2 */}-errorMessage`;
  const cityError = (_c = formState.errors[city]) == null ? void 0 : _c.message;
  const cityErrorId = `${"city" /* CITY */}-errorMessage`;
  const stateError = (_d = formState.errors[state]) == null ? void 0 : _d.message;
  const stateErrorId = `${"state" /* STATE */}-errorMessage`;
  const postalError = (_e = formState.errors[postal]) == null ? void 0 : _e.message;
  const postalErrorId = `${"postal" /* POSTAL */}-errorMessage`;
  const validate = {
    isValidCharacters: (value) => validateIsValidCharacters(value) || formatMessage({ id: "WALLET_INVALID_CHARACTER_ERROR_MESSAGE" })
  };
  return /* @__PURE__ */ React10.createElement(
    Fieldset3,
    {
      id: NEW_ADDRESS_HINT_ID,
      css: {
        ".GDS-fieldset-legend": {
          display: "block"
        }
      },
      legend: /* @__PURE__ */ React10.createElement(HeadingText4, { size: "lg", level: "3" }, formatMessage({ id: "CHOOSE_NEW_ADDRESS" })),
      hint: /* @__PURE__ */ React10.createElement(ParagraphText3, null, formatMessage({ id: "CHOOSE_NEW_ADDRESS_DESC" }))
    },
    /* @__PURE__ */ React10.createElement(StackLayout4, { spacing: "$oneAndHalf", horizontalAlignment: "stretch" }, /* @__PURE__ */ React10.createElement(Box4, null, /* @__PURE__ */ React10.createElement(StyledInputLabel, { htmlFor: "addressLine1" /* ADDRESS_LINE_1 */, required: true }, formatMessage({ id: "ADDRESS_LINE_1" })), /* @__PURE__ */ React10.createElement(
      TextInput,
      __spreadValues({
        id: "addressLine1" /* ADDRESS_LINE_1 */,
        maxLength: 55,
        autoComplete: "address-line1",
        inputStatus: addressLine1Error ? "error" : void 0,
        "aria-describedby": addressLine1Error ? addressLine1ErrorId : void 0
      }, register(addressLine12, {
        required: requiredFieldError("addressLine1" /* ADDRESS_LINE_1 */),
        validate
      }))
    ), addressLine1Error && /* @__PURE__ */ React10.createElement(InputStatusMessage, { inputStatus: "error", id: addressLine1ErrorId }, addressLine1Error)), /* @__PURE__ */ React10.createElement(Box4, null, /* @__PURE__ */ React10.createElement(StyledInputLabel, { htmlFor: "addressLine2" /* ADDRESS_LINE_2 */ }, formatMessage({ id: "ADDRESS_LINE_2" })), /* @__PURE__ */ React10.createElement(
      TextInput,
      __spreadValues({
        id: "addressLine2" /* ADDRESS_LINE_2 */,
        maxLength: 55,
        autoComplete: "address-line2",
        inputStatus: addressLine2Error ? "error" : void 0,
        "aria-describedby": addressLine2Error ? addressLine2ErrorId : void 0
      }, register(orderNewCardFormInputNames.addressLine2, {
        maxLength: {
          value: 55,
          message: formatMessage(
            { id: "UNIQUE_IDENTIFIER_MAX_LENGTH_ERROR" },
            { length: 55 }
          )
        },
        validate
      }))
    ), addressLine2Error && /* @__PURE__ */ React10.createElement(InputStatusMessage, { inputStatus: "error", id: addressLine2ErrorId }, addressLine2Error)), /* @__PURE__ */ React10.createElement(Box4, null, /* @__PURE__ */ React10.createElement(StyledInputLabel, { htmlFor: "city" /* CITY */, required: true }, formatMessage({ id: "CITY" })), /* @__PURE__ */ React10.createElement(
      TextInput,
      __spreadValues({
        id: "city" /* CITY */,
        maxLength: 30,
        autoComplete: "address-level2",
        "aria-describedby": cityError ? cityErrorId : void 0,
        inputStatus: cityError ? "error" : void 0
      }, register(city, {
        required: requiredFieldError("city" /* CITY */),
        maxLength: 30,
        pattern: {
          value: CITY_VALIDATION_REGEX,
          message: formatMessage({
            id: "WALLET_ORDER_NEW_CARD_NO_CITY_NUMBERS_ERROR"
          })
        },
        validate
      }))
    ), cityError && /* @__PURE__ */ React10.createElement(InputStatusMessage, { inputStatus: "error", id: cityErrorId }, cityError)), /* @__PURE__ */ React10.createElement(Box4, null, /* @__PURE__ */ React10.createElement(StyledInputLabel, { htmlFor: "state" /* STATE */, required: true }, formatMessage({ id: "STATE" })), /* @__PURE__ */ React10.createElement(
      Select,
      __spreadValues({
        id: "state" /* STATE */,
        options: transformedStateOptions,
        placeholder: formatMessage({ id: "SELECT_STATE" }),
        autoComplete: "address-level1",
        "aria-describedby": stateError ? stateErrorId : void 0,
        inputStatus: stateError ? "error" : void 0
      }, register(state, {
        required: requiredFieldError("state" /* STATE */),
        validate
      }))
    ), stateError && /* @__PURE__ */ React10.createElement(InputStatusMessage, { inputStatus: "error", id: stateErrorId }, stateError)), /* @__PURE__ */ React10.createElement(Box4, null, /* @__PURE__ */ React10.createElement(StyledInputLabel, { htmlFor: "postal" /* POSTAL */, required: true }, formatMessage({ id: "ZIP_CODE" })), /* @__PURE__ */ React10.createElement(
      TextInput,
      __spreadValues({
        id: "postal" /* POSTAL */,
        autoComplete: "postal-code",
        pattern: "[0-9]*",
        maxLength: 5,
        "aria-describedby": postalError ? postalErrorId : void 0,
        inputStatus: postalError ? "error" : void 0
      }, register(postal, {
        required: requiredFieldError("postal" /* POSTAL */),
        maxLength: 5,
        pattern: {
          value: ZIP_CODE_VALIDATION_REGEX,
          message: formatMessage({ id: "INVALID_ZIP_CODE_NO_FORMAT" })
        },
        validate
      }))
    ), postalError && /* @__PURE__ */ React10.createElement(InputStatusMessage, { inputStatus: "error", id: postalErrorId }, postalError)))
  );
};

// src/components/confirmation-screen.component.tsx
import * as React11 from "react";
import {
  Box as Box5,
  HeadingText as HeadingText5,
  Icon as Icon2,
  ParagraphText as ParagraphText4,
  StackItem as StackItem2,
  StackLayout as StackLayout5
} from "@leagueplatform/genesis-core";
import { useFormContext as useFormContext6 } from "@leagueplatform/web-common";
import { useIntl as useIntl6 } from "@leagueplatform/locales";
var AddressCard = ({ deliveryAddress }) => {
  const { formatMessage } = useIntl6();
  const { address1, address2, city: city2, state: state2, postal: postal2, isDefault: isDefault3 } = deliveryAddress;
  const isDefaultAddressBoolean = isDefault3 === "true";
  return /* @__PURE__ */ React11.createElement(StackItem2, { css: { flexDirection: "row", marginTop: "$oneAndHalf" } }, /* @__PURE__ */ React11.createElement(
    Box5,
    {
      css: {
        backgroundColor: "$surfaceBackgroundSecondary",
        padding: "$threeQuarters",
        borderRadius: "$circle",
        height: "fit-content",
        margin: "auto",
        marginInlineEnd: "$one"
      }
    },
    /* @__PURE__ */ React11.createElement(Icon2, { icon: "descriptiveMail", tint: "$onSurfaceIconPrimary" })
  ), /* @__PURE__ */ React11.createElement(Box5, null, /* @__PURE__ */ React11.createElement(HeadingText5, { level: "4", size: "md" }, isDefaultAddressBoolean ? formatMessage({ id: "DEFAULT_ADDRESS" }) : formatMessage({ id: "NEW_ADDRESS" })), /* @__PURE__ */ React11.createElement(Box5, null, /* @__PURE__ */ React11.createElement(
    ParagraphText4,
    {
      as: "span",
      css: { marginBlockEnd: "0 !important", display: "block" }
    },
    `${address1} ${address2 || ""}`
  ), /* @__PURE__ */ React11.createElement(
    ParagraphText4,
    {
      as: "span",
      css: { display: "block" }
    },
    `${city2}, ${state2}, ${postal2}`
  ))));
};
var {
  addressLine1: addressLine1Input,
  addressLine2: addressLine2Input,
  city: cityInput2,
  state: stateInput2,
  postal: postalInput2,
  isDefault: isDefaultAddress
} = orderNewCardFormInputNames;
var ConfirmationScreen = ({
  analyticsData,
  members
}) => {
  const { formatMessage } = useIntl6();
  const { getValues } = useFormContext6();
  useWalletDetailScreenLoaded(
    "order a new card confirmation screen" /* ORDER_NEW_CARD_CONFIRMATION_STEP */,
    analyticsData
  );
  const [address1, address2, city2, state2, postal2, isDefault3] = getValues([
    addressLine1Input,
    addressLine2Input,
    cityInput2,
    stateInput2,
    postalInput2,
    isDefaultAddress
  ]);
  const deliveryAddress = {
    address1,
    address2,
    city: city2,
    state: state2,
    postal: postal2,
    isDefault: isDefault3
  };
  return /* @__PURE__ */ React11.createElement(StackLayout5, null, /* @__PURE__ */ React11.createElement(HeadingText5, { size: "lg", level: "3" }, formatMessage({ id: "CONFIRM_DETAILS" })), /* @__PURE__ */ React11.createElement(MemberCard, { headingLevel: 4, members }), /* @__PURE__ */ React11.createElement(AddressCard, { deliveryAddress }));
};

// src/components/end-screen.component.tsx
import * as React12 from "react";
import {
  Box as Box6,
  HeadingText as HeadingText6,
  ParagraphText as ParagraphText5,
  StackLayout as StackLayout6,
  ImageMessage,
  Button
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl7 } from "@leagueplatform/locales";
import { handleStaticAsset } from "@leagueplatform/asset-config";
var EndScreen = ({
  onClick,
  status,
  analyticsData
}) => {
  const isSuccess = status === "success";
  const isLoading = status === "loading";
  const { formatMessage } = useIntl7();
  const SUCCESS_IMAGE = handleStaticAsset(
    "ORDER_NEW_CARD_SUCCESS" /* ORDER_NEW_CARD_SUCCESS */
  );
  const ERROR_IMAGE = handleStaticAsset(
    "ORDER_NEW_CARD_ERROR" /* ORDER_NEW_CARD_ERROR */
  );
  const logScreenLoaded = useWalletDetailScreenLoaded;
  if (isSuccess) {
    logScreenLoaded("order a new card success screen" /* ORDER_NEW_CARD_SUCCESS */, analyticsData);
  }
  return /* @__PURE__ */ React12.createElement(Box6, { css: { padding: "$none $two" } }, /* @__PURE__ */ React12.createElement(
    ImageMessage,
    {
      image: isSuccess ? SUCCESS_IMAGE : ERROR_IMAGE,
      imageGap: "$twoAndHalf"
    },
    /* @__PURE__ */ React12.createElement(StackLayout6, { horizontalAlignment: "center", spacing: "$half" }, /* @__PURE__ */ React12.createElement(HeadingText6, { level: "3", size: "lg" }, isSuccess ? formatMessage({ id: "SUCCESS" }) : formatMessage({ id: "ERROR_STATE_TITLE" })), /* @__PURE__ */ React12.createElement(ParagraphText5, null, /* @__PURE__ */ React12.createElement(
      ParagraphText5,
      {
        as: "span",
        css: { display: "block", textAlign: "center" }
      },
      isSuccess ? formatMessage({ id: "MEMBER_CARD_ON_ITS_WAY" }) : formatMessage({ id: "ERROR_HEADING" })
    ), /* @__PURE__ */ React12.createElement(
      ParagraphText5,
      {
        as: "span",
        css: { display: "block", textAlign: "center" }
      },
      isSuccess ? formatMessage({ id: "MEMBER_CARD_ARRIVAL" }) : formatMessage({ id: "TRY_LATER" })
    )), /* @__PURE__ */ React12.createElement(
      Button,
      {
        onClick,
        width: "fillContainer",
        css: { marginTop: "$twoAndHalf" },
        loading: isLoading,
        disabled: isLoading
      },
      isSuccess ? formatMessage({ id: "CLOSE" }) : formatMessage({ id: "RESUBMIT" })
    ))
  ));
};

// src/components/exit-intent-screen.component.tsx
import * as React13 from "react";
import {
  Box as Box7,
  HeadingText as HeadingText7,
  ParagraphText as ParagraphText6,
  StackLayout as StackLayout7,
  ImageMessage as ImageMessage2,
  Button as Button2
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl8 } from "@leagueplatform/locales";
import { handleStaticAsset as handleStaticAsset2 } from "@leagueplatform/asset-config";
import { EVENT_NAME as EVENT_NAME2 } from "@leagueplatform/analytics";
var ExitIntentScreen = ({
  cancelFunction,
  continueFunction,
  analyticsData
}) => {
  const { formatMessage } = useIntl8();
  const trackCancelEventCallback = useWalletDetailAnalytics(
    void 0,
    analyticsData
  );
  const LEAVE_OR_EXIT_WARNING_IMAGE = handleStaticAsset2(
    "LEAVE_OR_EXIT_WARNING" /* LEAVE_OR_EXIT_WARNING */
  );
  useWalletDetailScreenLoaded(
    "order a new card cancel" /* ORDER_NEW_CARD_CANCEL_ORDER */,
    analyticsData
  );
  const handleClose = React13.useCallback(() => {
    trackCancelEventCallback(EVENT_NAME2.BUTTON_CLICKED, {
      screen_name: "order a new card cancel" /* ORDER_NEW_CARD_CANCEL_ORDER */,
      detail: "cancel order"
    });
    cancelFunction();
  }, [cancelFunction, trackCancelEventCallback]);
  return /* @__PURE__ */ React13.createElement(
    Box7,
    {
      css: {
        display: "flex",
        margin: "0 auto",
        backgroundColor: "$surfaceBackgroundPrimary",
        borderRadius: "$large",
        boxShadow: "$dropdown",
        flexDirection: "column",
        overflow: "hidden auto",
        width: ACTIVITY_CONTENT_BASE_WIDTH,
        gap: "$one",
        padding: "$three"
      }
    },
    /* @__PURE__ */ React13.createElement(ImageMessage2, { image: LEAVE_OR_EXIT_WARNING_IMAGE, imageGap: "$twoAndHalf" }, /* @__PURE__ */ React13.createElement(StackLayout7, { horizontalAlignment: "center", spacing: "$half" }, /* @__PURE__ */ React13.createElement(HeadingText7, { level: "3", size: "lg", css: { textAlign: "center" } }, formatMessage({ id: "CANCEL_ORDER_NEW_CARD_TITLE" })), /* @__PURE__ */ React13.createElement(ParagraphText6, null, formatMessage({ id: "CANCEL_ORDER_NEW_CARD_DESC" })), /* @__PURE__ */ React13.createElement(
      Button2,
      {
        onClick: handleClose,
        width: "fillContainer",
        css: { marginTop: "$twoAndHalf", textTransform: "capitalize" }
      },
      formatMessage({ id: "CANCEL_ORDER" })
    ), /* @__PURE__ */ React13.createElement(
      Button2,
      {
        priority: "secondary",
        onClick: continueFunction,
        width: "fillContainer",
        css: { marginTop: "$one", textTransform: "capitalize" }
      },
      formatMessage({ id: "KEEP_GOING" })
    )))
  );
};

// src/components/multi-step-footer/order-new-card-footer.component.tsx
import React17 from "react";
import { useIntl as useIntl10 } from "@leagueplatform/locales";
import {
  BodyOneSecondary,
  genesisStyled as genesisStyled2,
  Box as Box9,
  css as css2
} from "@leagueplatform/genesis-commons";
import { VisuallyHidden } from "@leagueplatform/genesis-core";

// src/components/multi-step-footer/multi-step-footer-buttons.component.tsx
import React15 from "react";
import { QuietButton as QuietButton2 } from "@leagueplatform/genesis-commons";
import { Button as Button3, Icon as Icon3 } from "@leagueplatform/genesis-core";
import { ViewTransitionController } from "@leagueplatform/health-journey-common";
import { useIntl as useIntl9 } from "@leagueplatform/locales";

// src/components/multi-step-footer/circle-button.component.tsx
import React14 from "react";
import {
  css,
  Flex,
  PrimaryButton,
  QuietButton
} from "@leagueplatform/genesis-commons";
var CircleButton = ({
  css: cssOverrides,
  as = PrimaryButton,
  disabled,
  children,
  onClick,
  type,
  label
}) => /* @__PURE__ */ React14.createElement(
  Flex,
  {
    alignItems: "center",
    as: type === "submit" ? QuietButton : as,
    "aria-label": label,
    disabled,
    borderRadius: "circle",
    color: "interactive.action.primary",
    justifyContent: "center",
    opacity: 1,
    size: "three",
    transition: "background 0.15s ease-out, color 0.15s ease-out",
    type: type || null,
    css: css(__spreadProps(__spreadValues({}, cssOverrides), {
      "&:before": {
        borderRadius: "50%"
      }
    })),
    onClick
  },
  children
);

// src/components/multi-step-footer/multi-step-footer-buttons.component.tsx
var { SHORT } = TRANSITION_DURATION_MS;
var ButtonTransition = ({
  views,
  handleActiveView,
  css: css3
}) => /* @__PURE__ */ React15.createElement(
  ViewTransitionController,
  {
    views,
    handleActiveView,
    css: css3,
    duration: SHORT,
    transitionType: "fade"
  }
);
var CircleIcon = ({
  icon,
  onClick,
  disabled,
  css: css3,
  type,
  label
}) => /* @__PURE__ */ React15.createElement(
  CircleButton,
  {
    as: QuietButton2,
    onClick,
    disabled,
    css: css3,
    type,
    label
  },
  /* @__PURE__ */ React15.createElement(Icon3, { icon, css: { display: "block" } })
);
var SubmitButton = (_a) => {
  var _b = _a, {
    onClick,
    disabled,
    buttonText
  } = _b, props = __objRest(_b, [
    "onClick",
    "disabled",
    "buttonText"
  ]);
  return /* @__PURE__ */ React15.createElement(
    Button3,
    __spreadValues({
      priority: "primary",
      onClick,
      disabled,
      css: {
        paddingY: "$threeQuarters",
        textTransform: "uppercase",
        textWrap: "nowrap"
      }
    }, props),
    buttonText
  );
};
var PrevButton = ({ currentPage, onClick, css: css3, disabled }) => {
  const { formatMessage } = useIntl9();
  const buttons = {
    ["ArrowBack" /* ArrowBack */]: {
      view: CircleIcon,
      props: {
        icon: "interfaceArrowBack",
        disabled,
        onClick,
        label: formatMessage({ id: "BENEFITS_ORDER_NEW_CARD_PREVIOUS_LABEL" }),
        type: "button"
      }
    }
  };
  const handleActiveButton = () => {
    if (currentPage)
      return "ArrowBack" /* ArrowBack */;
    return "";
  };
  return /* @__PURE__ */ React15.createElement(
    ButtonTransition,
    {
      views: buttons,
      handleActiveView: handleActiveButton,
      css: css3
    }
  );
};
var NextButton = ({
  currentPage,
  totalPages,
  disabled,
  onClick,
  css: css3,
  isLoading,
  onSubmit
}) => {
  const commonProps = { onClick, disabled };
  const { formatMessage } = useIntl9();
  const buttons = {
    ["ArrowForward" /* ArrowForward */]: {
      view: CircleIcon,
      props: __spreadValues({
        icon: "interfaceArrowForward",
        label: formatMessage({
          id: "BENEFITS_ORDER_NEW_CARD_NEXT_LABEL"
        }),
        type: "button"
      }, commonProps)
    },
    ["Check" /* Check */]: {
      view: SubmitButton,
      props: __spreadValues({
        type: "submit",
        onSubmit,
        buttonText: formatMessage({ id: "ORDER_CARD" }),
        loading: isLoading
      }, commonProps)
    },
    ["Spinner" /* Loading */]: {
      view: SubmitButton,
      props: __spreadValues({
        buttonText: formatMessage({ id: "ORDER_CARD" })
      }, commonProps)
    }
  };
  const isLastPage = currentPage === totalPages - 1;
  const handleActiveButton = () => {
    if (isLastPage)
      return "Check" /* Check */;
    if (isLoading)
      return "Spinner" /* Loading */;
    return "ArrowForward" /* ArrowForward */;
  };
  return /* @__PURE__ */ React15.createElement(
    ButtonTransition,
    {
      views: buttons,
      handleActiveView: handleActiveButton,
      css: css3
    }
  );
};

// src/components/multi-step-footer/multi-step-page-progress.component.tsx
import React16 from "react";
import {
  Flex as Flex2,
  Box as Box8,
  genesisStyled
} from "@leagueplatform/genesis-commons";
var PageIndicator = genesisStyled(Box8)`
  position: relative;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.interactive.action.disabled};
  border-radius: ${({ theme }) => theme.radii.medium}px;
  border: none;
  height: ${({ theme }) => theme.sizes.quarter}px;
  width: 100%;
  &:not(&:first-of-type){
    margin-inline-start: ${({ theme }) => theme.space.quarter}px;
  }
  &:before {
    content: '';
    position: absolute;
    inset: 0;
    transform: scaleX(${({ isActive }) => Number(isActive)});
    transform-origin: start;
    background-color: ${({ theme }) => theme.colors.interactive.action.primary};
    transition: transform ${TRANSITIONS.PAGE};
  }
`;
var MultiStepPageProgress = ({
  css: css3,
  totalPages,
  currentPage
}) => {
  const pageIndices = [...Array(totalPages).keys()];
  return /* @__PURE__ */ React16.createElement(
    Flex2,
    {
      justifyContent: "space-between",
      width: "100%",
      padding: " 0 25%",
      marginBottom: "oneAndHalf",
      css: css3
    },
    pageIndices.map((pageIndex) => /* @__PURE__ */ React16.createElement(
      PageIndicator,
      {
        key: `page-progress-${pageIndex}`,
        isActive: currentPage >= pageIndex,
        currentPage,
        pageIndex
      }
    ))
  );
};

// src/components/multi-step-footer/order-new-card-footer.component.tsx
var { Top, Start, Center, End, Bottom } = MultiStepFooterAreas;
var footerPlacement = {
  [Top]: css2({ gridArea: Top, justifySelf: "center" }),
  [Start]: css2({ gridArea: Start, justifySelf: "start" }),
  [Center]: css2({ gridArea: Center, justifySelf: "center" }),
  [End]: css2({ gridArea: End, justifySelf: "end" }),
  [Bottom]: css2({ gridArea: Bottom, justifySelf: "center" })
};
var FooterLayout = genesisStyled2(Box9)`
  align-items: center;
  display: grid;
  grid-template-areas:
  "top top top"
  "start center end"
  "bottom bottom bottom";
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto;
  width: 100%;
`;
var OrderNewCardFooter = ({
  totalPages,
  currentPage,
  disabled,
  onNext,
  onPrev,
  isLoading,
  onSubmit
}) => {
  const { formatMessage } = useIntl10();
  const isMultiPage = totalPages > 1;
  const copy = {
    pageProgress: formatMessage(
      { id: "X_OF_Y" },
      { current: currentPage + 1, total: totalPages }
    )
  };
  return /* @__PURE__ */ React17.createElement(FooterLayout, { marginTop: "one" }, isMultiPage && /* @__PURE__ */ React17.createElement(
    MultiStepPageProgress,
    {
      css: footerPlacement[Top],
      currentPage,
      totalPages
    }
  ), isMultiPage && /* @__PURE__ */ React17.createElement(
    PrevButton,
    {
      currentPage,
      disabled,
      onClick: onPrev,
      css: footerPlacement[Start]
    }
  ), isMultiPage && /* @__PURE__ */ React17.createElement(
    BodyOneSecondary,
    {
      textAlign: "center",
      css: footerPlacement[Center],
      "aria-live": "polite"
    },
    /* @__PURE__ */ React17.createElement(VisuallyHidden, null, formatMessage({ id: "STEP" })),
    copy.pageProgress
  ), isLoading ? /* @__PURE__ */ React17.createElement(
    NextButton,
    {
      css: footerPlacement[End],
      currentPage,
      totalPages,
      disabled,
      onClick: onNext,
      isLoading
    }
  ) : /* @__PURE__ */ React17.createElement(
    NextButton,
    {
      css: footerPlacement[End],
      currentPage,
      totalPages,
      disabled,
      onClick: onNext,
      onSubmit
    }
  ));
};

// src/components/order-new-card-form.component.tsx
var HEADING_ID = "order-new-card-form";
var CardContainer = styled3(Box10, {
  display: "flex",
  backgroundColor: "$surfaceBackgroundPrimary",
  borderRadius: "$large",
  boxShadow: "$dropdown",
  flexDirection: "column",
  height: "100%",
  minWidth: "100%",
  position: "relative",
  width: "100%",
  gap: "$one",
  padding: "$twoAndHalf"
});
var getBenefitAnalyticsEventData = (stepName, numberOfSelectedUsers) => {
  switch (stepName) {
    case "SelectMembersStep":
      return {
        product_area: PRODUCT_AREA2.WALLET,
        screen_name: "order a new card" /* ORDER_NEW_CARD_SELECT_MEMBER_STEP */,
        detail: "select user" /* SELECT_USER */,
        sub_detail: `${numberOfSelectedUsers}`
      };
    case "SelectAddressStep":
      return {
        product_area: PRODUCT_AREA2.WALLET,
        screen_name: "order a new card" /* ORDER_NEW_CARD_SELECT_MEMBER_STEP */,
        detail: "select a delivery address" /* SELECT_DELIVERY_ADDRESS */,
        sub_detail: "continue" /* CONTINUE */
      };
    case "NewAddressStep":
      return {
        product_area: PRODUCT_AREA2.WALLET,
        screen_name: "order a new card enter new address" /* ORDER_NEW_CARD_NEW_ADDRESS_STEP */,
        detail: "confirm your details" /* CONFIRM_DETAILS */
      };
    case "ConfirmationScreen":
      return {
        product_area: PRODUCT_AREA2.WALLET,
        screen_name: "order a new card confirmation screen" /* ORDER_NEW_CARD_CONFIRMATION_STEP */,
        detail: "select order card" /* SELECT_ORDER_CARD */
      };
    default:
      return {
        product_area: PRODUCT_AREA2.WALLET,
        screen_name: "order a new card" /* ORDER_NEW_CARD_SELECT_MEMBER_STEP */
      };
  }
};
var LegacyOrderNewCardForm = ({
  isExiting,
  cancelFunction,
  continueFunction,
  disableConfirmExitFlag,
  benefitId,
  dependents = [],
  analyticsData
}) => {
  const { formatMessage } = useIntl11();
  const methods = useForm();
  const { isLoading: isMembersLoading, memberOptions } = useSelectMembersStep(dependents);
  const {
    mutate: submitIdCard,
    isLoading: isSubmitLoading,
    status
  } = useSubmitOrderNewCardMutation(benefitId);
  const newAddressSteps = React18.useMemo(
    () => [
      SelectMembersStep,
      SelectAddressStep,
      NewAddressStep,
      ConfirmationScreen,
      EndScreen
    ],
    []
  );
  const defaultAddressSteps = React18.useMemo(
    () => [SelectMembersStep, SelectAddressStep, ConfirmationScreen, EndScreen],
    []
  );
  const { isDefault: isDefault3 } = orderNewCardFormInputNames;
  const isDefaultAddress2 = methods.watch(isDefault3);
  const [steps, setSteps] = React18.useState(defaultAddressSteps);
  const [currentStep, setCurrentStep] = React18.useState(0);
  const isFooterActive = currentStep !== steps.length - 1;
  const isConfirmationScreen = currentStep === steps.length - 2;
  const modalRef = React18.useRef(null);
  const handleFocus = () => {
    var _a;
    (_a = modalRef.current) == null ? void 0 : _a.focus();
  };
  const sendBenefitAnalyticsEvent = useWalletDetailAnalytics(
    void 0,
    analyticsData
  );
  React18.useEffect(() => {
    handleFocus();
  }, [currentStep]);
  React18.useEffect(() => {
    const isDefaultAddressSelected = checkIsDefaultAddress(isDefaultAddress2);
    if (isDefaultAddressSelected === false) {
      setSteps(newAddressSteps);
    } else {
      setSteps(defaultAddressSteps);
    }
  }, [currentStep, defaultAddressSteps, isDefaultAddress2, newAddressSteps]);
  React18.useEffect(() => {
    if (status === "success" && isConfirmationScreen || status === "error" && isConfirmationScreen) {
      setCurrentStep(currentStep + 1);
      disableConfirmExitFlag();
    }
  }, [
    currentStep,
    disableConfirmExitFlag,
    isConfirmationScreen,
    status,
    steps.length
  ]);
  const goBack = () => {
    setCurrentStep(currentStep - 1);
  };
  const validateForm = React18.useCallback(() => __async(void 0, null, function* () {
    const {
      setFocus,
      trigger,
      formState: { errors, isValid }
    } = methods;
    yield trigger();
    if (isValid) {
      return true;
    }
    const firstInstanceOfError = Object.keys(errors)[0];
    setFocus(firstInstanceOfError);
    return false;
  }), [methods]);
  const sendOrderNewCardAnalyticsEvent = React18.useCallback(() => {
    const { memberList: memberList3 } = orderNewCardFormInputNames;
    const numberOfSelectedUsers = methods.getValues(memberList3).length;
    sendBenefitAnalyticsEvent(
      EVENT_NAME3.BUTTON_CLICKED,
      getBenefitAnalyticsEventData(
        steps[currentStep].name,
        numberOfSelectedUsers
      )
    );
  }, [currentStep, methods, sendBenefitAnalyticsEvent, steps]);
  const onNext = React18.useCallback(() => __async(void 0, null, function* () {
    sendOrderNewCardAnalyticsEvent();
    yield validateForm();
    if (!isConfirmationScreen && methods.formState.isValid) {
      setCurrentStep(currentStep + 1);
    }
  }), [
    currentStep,
    isConfirmationScreen,
    methods,
    sendOrderNewCardAnalyticsEvent,
    validateForm
  ]);
  const onSubmit = React18.useCallback(
    (data) => {
      const isErrorScreen = currentStep === steps.length - 1 && status === "error";
      if (currentStep === steps.length - 2 || isErrorScreen) {
        submitIdCard(data);
      }
    },
    [currentStep, status, steps.length, submitIdCard]
  );
  const handleRetrySubmit = React18.useCallback(() => {
    const formValues = methods.getValues();
    onSubmit(formValues);
  }, [methods, onSubmit]);
  const handleKeyPress = (e) => __async(void 0, null, function* () {
    if (
      // prevent onNext from firing on the end screen
      e.key === "Enter" && currentStep !== steps.length - 1
    ) {
      yield onNext();
    }
  });
  return /* @__PURE__ */ React18.createElement(MultiStepLayout, null, isExiting && /* @__PURE__ */ React18.createElement(
    ExitIntentScreen,
    {
      analyticsData,
      cancelFunction,
      continueFunction
    }
  ), /* @__PURE__ */ React18.createElement(
    FormProvider,
    __spreadValues({}, methods),
    /* @__PURE__ */ React18.createElement(
      StackLayout8,
      {
        tabIndex: -1,
        "aria-labelledby": HEADING_ID,
        ref: modalRef,
        "aria-live": "polite",
        spacing: "$oneAndHalf",
        verticalAlignment: "center",
        css: {
          width: "100%",
          height: "100%",
          position: "static",
          display: isExiting ? "none" : "",
          // override GDS outline in favour of our own on the correct element
          "&:focus, &:focus-visible": {
            outline: "none !important"
          },
          "&:focus-visible .card-container": {
            outline: "$borderWidths$outerFocus solid $interactiveFocusOuter"
          }
        },
        as: "form",
        onSubmit: methods.handleSubmit(onSubmit),
        onKeyDown: handleKeyPress
      },
      /* @__PURE__ */ React18.createElement(CardContainer, { className: "card-container" }, /* @__PURE__ */ React18.createElement(
        HeadingText8,
        {
          id: HEADING_ID,
          size: "xl",
          level: "2",
          css: { textAlign: "center", width: "100%" }
        },
        formatMessage({ id: "ORDER_NEW_CARD_HEADING" })
      ), /* @__PURE__ */ React18.createElement(MultiStepSlider, null, steps.map((ComponentStep, i) => /* @__PURE__ */ React18.createElement(
        MultiStepSlide,
        {
          key: `step-${i}`,
          activeIndex: currentStep,
          slideIndex: i
        },
        /* @__PURE__ */ React18.createElement(
          ComponentStep,
          {
            status,
            onClick: status === "success" ? cancelFunction : handleRetrySubmit,
            analyticsData,
            members: memberOptions
          }
        )
      )))),
      isFooterActive && /* @__PURE__ */ React18.createElement(
        OrderNewCardFooter,
        {
          totalPages: steps.length - 1,
          currentPage: currentStep,
          onNext,
          onPrev: goBack,
          onSubmit,
          isLoading: isSubmitLoading,
          disabled: isMembersLoading || isSubmitLoading
        }
      )
    )
  ));
};

// src/components/order-new-card.component.tsx
var LegacyOrderNewCard = ({
  benefitId,
  isOpen,
  onComplete,
  dependents,
  elementToFocusOnClose: elementToFocusOnCloseProp,
  vendorId,
  title,
  benefitSource,
  productType
}) => {
  const { formatMessage } = useIntl12();
  const [isShown, setIsShown] = React19.useState(isOpen);
  const [isExiting, setIsExiting] = React19.useState(false);
  const [isConfirmExitFlagEnabled, setIsConfirmExitFlagEnabled] = React19.useState(true);
  const elementToFocusOnClose = React19.useRef(elementToFocusOnCloseProp);
  const analyticsData = React19.useMemo(
    () => ({
      benefitId,
      benefitName: title,
      benefitSource,
      productType,
      vendorId
    }),
    [benefitId, vendorId, title, benefitSource, productType]
  );
  const handleClose = () => {
    if (isConfirmExitFlagEnabled && !isExiting) {
      setIsExiting(true);
      return;
    }
    setIsShown(false);
    setIsExiting(false);
    setIsConfirmExitFlagEnabled(true);
    onComplete == null ? void 0 : onComplete();
    if (elementToFocusOnClose.current) {
      setTimeout(() => {
        var _a;
        (_a = elementToFocusOnClose.current) == null ? void 0 : _a.focus();
      }, 0);
    }
  };
  const handleContinueOrder = () => {
    setIsExiting(false);
  };
  const disableConfirmExitFlag = () => {
    setIsConfirmExitFlagEnabled(false);
  };
  return /* @__PURE__ */ React19.createElement(
    Modal.Root,
    {
      open: isShown,
      onOpenChange: (isOpenChange) => {
        if (isOpenChange === false) {
          handleClose();
          return;
        }
        setIsShown(true);
      }
    },
    /* @__PURE__ */ React19.createElement(
      Modal.Content,
      {
        forceModalFocus: true,
        layout: "fullscreen",
        css: {
          ".GDS-modal": {
            width: "100vw",
            insetInlineStart: "0",
            height: "100vh",
            borderRadius: "$none",
            backgroundColor: "$surfaceBackgroundTertiary"
          },
          ".GDS-modal-close-button-wrapper": {
            display: "none"
          }
        }
      },
      /* @__PURE__ */ React19.createElement(
        HeadingBar,
        {
          css: { backgroundColor: "transparent" },
          trailingAction: /* @__PURE__ */ React19.createElement(
            Button4,
            {
              css: { "& > *": { paddingInlineEnd: 0 } },
              priority: "secondary",
              quiet: true,
              icon: "tinyClose",
              size: "medium",
              onClick: handleClose
            },
            /* @__PURE__ */ React19.createElement(VisuallyHidden2, null, formatMessage({ id: "CLOSE" }))
          )
        }
      ),
      /* @__PURE__ */ React19.createElement(Modal.Title, null, /* @__PURE__ */ React19.createElement(VisuallyHidden2, null, formatMessage({ id: "ORDER_NEW_CARD_HEADING" }))),
      /* @__PURE__ */ React19.createElement(Modal.Description, null, /* @__PURE__ */ React19.createElement(
        LegacyOrderNewCardForm,
        {
          isExiting,
          cancelFunction: handleClose,
          continueFunction: handleContinueOrder,
          disableConfirmExitFlag,
          benefitId,
          dependents,
          analyticsData
        }
      ))
    )
  );
};

// src/hooks/use-legacy-order-new-card-store.hook.ts
import { create } from "zustand";
var initialState = {
  orderNewCardInstance: void 0
};
var legacyOrderNewCardStore = create(
  (set) => __spreadProps(__spreadValues({}, initialState), {
    setOrderNewCardInstance: (orderNewCardInstance) => set((state2) => __spreadProps(__spreadValues({}, state2), {
      orderNewCardInstance: __spreadValues(__spreadValues({}, state2.orderNewCardInstance), orderNewCardInstance)
    })),
    setIsOpen: (isOpen) => set((state2) => {
      const { orderNewCardInstance } = state2;
      if (!orderNewCardInstance) {
        return state2;
      }
      return __spreadProps(__spreadValues({}, state2), {
        orderNewCardInstance: __spreadProps(__spreadValues({}, orderNewCardInstance), {
          isOpen
        })
      });
    }),
    reset: () => set(() => __spreadValues({}, initialState))
  })
);
var useGetLegacyOrderNewCardInstance = () => {
  const orderNewCardInstance = legacyOrderNewCardStore(
    (state2) => state2.orderNewCardInstance
  );
  return orderNewCardInstance;
};
var useLegacyOrderNewCardStoreActions = () => {
  const setOrderNewCardInstance = legacyOrderNewCardStore(
    (state2) => state2.setOrderNewCardInstance
  );
  const reset = legacyOrderNewCardStore((state2) => state2.reset);
  return { setOrderNewCardInstance, reset };
};

// src/index.ts
initModule();
export {
  LegacyOrderNewCard,
  legacyOrderNewCardStore,
  useGetLegacyOrderNewCardInstance,
  useLegacyOrderNewCardStoreActions
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/legacy-order-new-card'] = window.leagueSDKsPresent['@leagueplatform/legacy-order-new-card'] || [];
    window.leagueSDKsPresent['@leagueplatform/legacy-order-new-card'].push('2.28.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/legacy-order-new-card'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/legacy-order-new-card module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map